import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`] || color;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66547 4.66572C6.2127 3.11849 8.31119 2.24927 10.4993 2.24927C12.6874 2.24927 14.7859 3.11849 16.3331 4.66572C17.8804 6.21295 18.7496 8.31144 18.7496 10.4995C18.7496 12.4362 18.0686 14.3027 16.8393 15.7789L21.5301 20.4697C21.823 20.7626 21.823 21.2375 21.5301 21.5304C21.2372 21.8233 20.7624 21.8233 20.4695 21.5304L15.7787 16.8396C14.3025 18.0689 12.436 18.7498 10.4993 18.7498C8.3112 18.7498 6.2127 17.8806 4.66547 16.3334C3.11825 14.7862 2.24902 12.6877 2.24902 10.4995C2.24902 8.31144 3.11825 6.21295 4.66547 4.66572ZM10.4993 3.74927C8.70902 3.74927 6.99206 4.46046 5.72614 5.72638C4.46021 6.9923 3.74902 8.70926 3.74902 10.4995C3.74902 12.2898 4.46021 14.0068 5.72614 15.2727C6.99206 16.5386 8.70902 17.2498 10.4993 17.2498C12.2896 17.2498 14.0066 16.5386 15.2725 15.2727C16.5384 14.0068 17.2496 12.2898 17.2496 10.4995C17.2496 8.70926 16.5384 6.9923 15.2725 5.72638C14.0066 4.46046 12.2896 3.74927 10.4993 3.74927Z"
        fill={colorValue}
      />
    </svg>
  );
};
